import mailStrings from 'owa-strings/owa-mail-strings';
var writeEmailCategoryKey = 'writeEmail';
var emailListCategoryKey = 'emailList';
var readEmailCategoryKey = 'readEmail';
var goToCategoryKey = 'goTo';
var emailActionsCategoryKey = 'emailActions';
export function getCommandCategories() {
    return [
        {
            category: writeEmailCategoryKey,
            displayName: mailStrings.writeEmailHeaderText,
        },
        {
            category: emailListCategoryKey,
            displayName: mailStrings.emailListHeaderText,
        },
        {
            category: readEmailCategoryKey,
            displayName: mailStrings.readEmailHeaderText,
        },
        {
            category: goToCategoryKey,
            displayName: mailStrings.goToHeaderText,
        },
        {
            category: emailActionsCategoryKey,
            displayName: mailStrings.emailActionsHeaderText,
        },
    ];
}
export function getCommands() {
    return {
        newMail: {
            category: writeEmailCategoryKey,
            description: mailStrings.newEmailCommand,
            hotmail: ['ctrl+n', 'n'],
            yahoo: 'n',
            gmail: 'c',
            owa: ['ctrl+n', 'n'],
        },
        sendMail: {
            category: writeEmailCategoryKey,
            description: mailStrings.sendEmailCommand,
            hotmail: ['ctrl+enter', 'alt+s'],
            yahoo: 'alt+s',
            gmail: 'ctrl+enter',
            owa: ['ctrl+enter', 'alt+s'],
        },
        reply: {
            category: writeEmailCategoryKey,
            description: mailStrings.replyEmailCommand,
            hotmail: 'r',
            yahoo: 'r',
            gmail: 'r',
            owa: ['r', 'ctrl+r'],
        },
        replyAll: {
            category: writeEmailCategoryKey,
            description: mailStrings.replyAllEmailCommand,
            hotmail: ['a', 'shift+r'],
            yahoo: 'a',
            gmail: 'a',
            owa: ['shift+r', 'ctrl+shift+r'],
        },
        forward: {
            category: writeEmailCategoryKey,
            description: mailStrings.forwardEmailCommand,
            hotmail: 'shift+f',
            yahoo: 'f',
            gmail: 'f',
            owa: ['shift+f', 'ctrl+shift+f'],
        },
        saveDraft: {
            category: writeEmailCategoryKey,
            description: mailStrings.saveDraftCommand,
            hotmail: 'ctrl+s',
            yahoo: 'ctrl+s',
            gmail: 'ctrl+s',
            owa: 'ctrl+s',
        },
        discardDraft: {
            category: writeEmailCategoryKey,
            description: mailStrings.discardDraftCommand,
            hotmail: 'esc',
            owa: 'esc',
        },
        gotoMail: {
            category: goToCategoryKey,
            description: mailStrings.goToMailCommand,
            hotmail: 'ctrl+shift+1',
            yahoo: 'ctrl+shift+1',
            gmail: 'ctrl+shift+1',
            owa: 'ctrl+shift+1',
        },
        gotoCalendar: {
            category: goToCategoryKey,
            description: mailStrings.goToCalendarCommand,
            hotmail: 'ctrl+shift+2',
            yahoo: 'ctrl+shift+2',
            gmail: 'ctrl+shift+2',
            owa: 'ctrl+shift+2',
        },
        gotoPeople: {
            category: goToCategoryKey,
            description: mailStrings.goToPeopleCommand,
            hotmail: 'ctrl+shift+3',
            yahoo: 'ctrl+shift+3',
            gmail: 'ctrl+shift+3',
            owa: 'ctrl+shift+3',
        },
        gotoTasks: {
            category: goToCategoryKey,
            description: mailStrings.goToTasksCommand,
            hotmail: 'ctrl+shift+4',
            yahoo: 'ctrl+shift+4',
            gmail: 'ctrl+shift+4',
            owa: 'ctrl+shift+4',
        },
        gotoInbox: {
            category: goToCategoryKey,
            description: mailStrings.goToInboxCommand,
            hotmail: 'g i',
            yahoo: 'm',
            gmail: 'g i',
            owa: 'g i',
        },
        gotoDrafts: {
            category: goToCategoryKey,
            description: mailStrings.goToDraftsCommand,
            hotmail: 'g d',
            gmail: 'g d',
            owa: 'g d',
        },
        gotoSent: {
            category: goToCategoryKey,
            description: mailStrings.goToSentCommand,
            hotmail: 'g s',
            gmail: 'g t',
            owa: 'g s',
        },
        gotoSearch: {
            category: goToCategoryKey,
            description: mailStrings.searchEmailCommand,
            hotmail: '/',
            yahoo: 's',
            gmail: '/',
            owa: 'alt+q',
        },
        undoAction: {
            category: emailActionsCategoryKey,
            description: mailStrings.undoCommand,
            hotmail: 'ctrl+z',
            yahoo: 'ctrl+z',
            gmail: 'ctrl+z',
            owa: 'ctrl+z',
        },
        selectAll: {
            category: emailListCategoryKey,
            description: mailStrings.selectAllMessagesCommand,
            hotmail: 'ctrl+a',
            yahoo: 'ctrl+a',
            gmail: 'ctrl+a',
            owa: 'ctrl+a',
        },
        deselectAll: {
            category: emailListCategoryKey,
            description: mailStrings.clearAllMessagesCommand,
            hotmail: 'esc',
            yahoo: 'esc',
            gmail: 'esc',
            owa: 'esc',
        },
        deleteMail: {
            category: emailActionsCategoryKey,
            description: mailStrings.deleteEmailCommand,
            hotmail: 'del',
            yahoo: 'del',
            gmail: '#',
            owa: 'del',
        },
        openMail: {
            category: readEmailCategoryKey,
            description: mailStrings.openEmailCommand,
            hotmail: ['o', 'enter'],
            gmail: 'o',
            owa: ['o', 'enter'],
        },
        closeMail: {
            category: readEmailCategoryKey,
            description: mailStrings.closeEmailCommand,
            hotmail: 'esc',
            yahoo: 'esc',
            gmail: 'u',
            owa: 'esc',
        },
        openNextItem: {
            category: readEmailCategoryKey,
            description: mailStrings.openNextItemCommand,
            hotmail: 'ctrl+.',
            yahoo: 'ctrl+.',
            gmail: 'j',
            owa: 'ctrl+.',
        },
        openPrevItem: {
            category: readEmailCategoryKey,
            description: mailStrings.openPreviousItemCommand,
            hotmail: 'ctrl+,',
            yahoo: 'ctrl+,',
            gmail: 'k',
            owa: 'ctrl+,',
        },
        expandCollapseAll: {
            category: readEmailCategoryKey,
            description: mailStrings.expandCollapseConversationCommand,
            hotmail: 'x',
            gmail: 'x',
            owa: 'x',
            yahoo: 'x',
        },
        softDeleteMail: {
            category: emailActionsCategoryKey,
            description: mailStrings.softDeleteCommand,
            hotmail: 'shift+del',
            yahoo: 'shift+del',
            gmail: 'shift+del',
            owa: 'shift+del',
        },
        newFolder: {
            category: emailActionsCategoryKey,
            description: mailStrings.newFolderCommand,
            hotmail: 'shift+e',
            yahoo: 'ctrl+shift+e',
            owa: 'shift+e',
        },
        markAsRead: {
            category: emailActionsCategoryKey,
            description: mailStrings.markReadCommand,
            hotmail: 'q',
            yahoo: 'k',
            gmail: 'shift+i',
            owa: ['q', 'ctrl+q'],
        },
        markAsUnread: {
            category: emailActionsCategoryKey,
            description: mailStrings.markUnreadCommand,
            hotmail: 'u',
            yahoo: 'shift+k',
            gmail: 'shift+u',
            owa: ['u', 'ctrl+u'],
        },
        toggleFlag: {
            category: emailActionsCategoryKey,
            description: mailStrings.flagEmailCommand,
            hotmail: 'ins',
            yahoo: 'l',
            gmail: 's',
            owa: 'ins',
        },
        archiveMail: {
            category: emailActionsCategoryKey,
            description: mailStrings.archiveCommand,
            hotmail: 'e',
            gmail: 'e',
            owa: 'e',
        },
        markAsJunk: {
            category: emailActionsCategoryKey,
            description: mailStrings.markJunkCommand,
            hotmail: 'j',
            gmail: 'shift+1',
            owa: 'j',
        },
        moveToFolder: {
            category: emailActionsCategoryKey,
            description: mailStrings.moveToFolder,
            hotmail: 'v',
            gmail: 'v',
            owa: 'v',
        },
        categorize: {
            category: emailActionsCategoryKey,
            description: mailStrings.categorize,
            hotmail: 'c',
            gmail: 'c',
            owa: 'c',
        },
        insertHyperlink: {
            category: writeEmailCategoryKey,
            description: mailStrings.insertHyperlinkCommand,
            hotmail: 'ctrl+k',
            gmail: 'ctrl+k',
            owa: 'ctrl+k',
        },
        keyboardShortcuts: {
            category: goToCategoryKey,
            description: mailStrings.showKeyboardShortcutsCommand,
            hotmail: '?',
            gmail: '?',
            owa: '?',
            yahoo: '?',
        },
    };
}
//# sourceMappingURL=MailModuleHotKeys.js.map